export type FlocktoryLoyaltyStatus = 'basic' | 'silver' | 'gold';

export interface FlocktoryUserLoyaltyDataLayerData {
  bonusPoints: number;
  loyaltyStatusId: number | null;
  loyaltyStatus: FlocktoryLoyaltyStatus | null;
}

const FLOCKTORY_USER_LOYALTY_EVENT = 'delikateska_user_loyalty';

export const pushFlocktoryUserLoyaltyToDataLayer = ({
  bonusPoints,
  loyaltyStatusId,
  loyaltyStatus
}: FlocktoryUserLoyaltyDataLayerData): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: FLOCKTORY_USER_LOYALTY_EVENT,
    delikateska_bonus_points: bonusPoints,
    delikateska_loyalty_status_id: loyaltyStatusId,
    delikateska_loyalty_status: loyaltyStatus
  });
};

export const pushFlocktoryGuestLoyaltyToDataLayer = (): void => {
  pushFlocktoryUserLoyaltyToDataLayer({
    bonusPoints: 0,
    loyaltyStatusId: null,
    loyaltyStatus: null
  });
};
